var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordingButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4246 7.59357C17.4246 4.88079 15.2901 2.68164 12.6571 2.68164C10.0241 2.68164 7.88965 4.88079 7.88965 7.59357V16.7157C7.88965 19.4285 10.0241 21.6277 12.6571 21.6277C15.2901 21.6277 17.4246 19.4285 17.4246 16.7157V7.59357Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44141 16.0142C2.44141 21.8271 7.01545 26.5397 12.6574 26.5397M12.6574 26.5397C18.2994 26.5397 22.8734 21.8271 22.8734 16.0142M12.6574 26.5397V30.75",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingButton);
export default __webpack_public_path__ + "static/media/RecordingButton.94907c15fd9cc18558d57f1e42c7bb2d.svg";
export { ForwardRef as ReactComponent };